import { Button, Typography } from '@mui/material';
import { AthleteTeamProfile, athleteDisplayName } from '@strength/domain';
import { useTranslation } from 'react-i18next';
import { Drawer, DrawerFooter, DrawerHeader } from '../../components/drawer';
import { AthleteAvatar } from '../../components/icons/athlete-avatar';
import { MultiSelect } from '../../components/input/multi-select';
import { getAgeFromBirthdate } from './utils';

const DataLabel = ({ label }: { label: string }) => {
  return <Typography sx={{ color: 'text.secondary' }}>{label}</Typography>;
};

export const AthleteProfile = ({
  athlete,
  open,
  onOpenChange,
}: {
  athlete: AthleteTeamProfile;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const fullName = athleteDisplayName(athlete);
  const { birthdate, primaryPhone, email, gender, tracks, attributes } =
    athlete;

  return (
    <Drawer open={open} onClose={() => onOpenChange(false)}>
      <DrawerHeader onClose={() => onOpenChange(false)}>
        <AthleteAvatar
          athlete={athlete}
          sx={{
            width: 100,
            height: 100,
            fontSize: 24,
            border: 3,
            borderColor: 'white',
            boxShadow: 1,
          }}
          imgSrc={athlete.imageUrl ?? ''}
        />
        <Typography variant="h2" sx={{ paddingTop: 2 }}>
          {fullName}
        </Typography>
      </DrawerHeader>

      <div className="grow px-8">
        <div className="grid grid-cols-2 gap-y-3 gap-x-6 mt-6">
          <DataLabel label={t('sport')} />
          <Typography>{attributes?.sportName ?? '-'}</Typography>
          <DataLabel label={t('positions')} />
          <Typography>
            {attributes?.positions && attributes?.positions?.length > 0
              ? attributes?.positions?.join(', ')
              : '-'}
          </Typography>
          <DataLabel label={t('dateOfBirth')} />
          <Typography>{birthdate ?? '-'}</Typography>
          <DataLabel label={t('emailAddress')} />
          <Typography sx={{ overflowWrap: 'anywhere' }}>
            {email ?? '-'}
          </Typography>
          <DataLabel label={t('phoneNumber')} />
          <Typography>{primaryPhone ?? '-'}</Typography>
          <DataLabel label={t('gender')} />
          <Typography>{gender ?? '-'}</Typography>
          <DataLabel label={t('age')} />
          <Typography>
            {(birthdate && getAgeFromBirthdate(birthdate)) ?? '-'}
          </Typography>
          <DataLabel label={t('athleteYear')} />
          <Typography>{attributes?.athleteYear ?? '-'}</Typography>
          <DataLabel label={t('jerseyNumber')} />
          <Typography>{attributes?.jerseyNumber ?? '-'}</Typography>
          <DataLabel label={t('athleteStatus')} />
          <Typography>{attributes?.athleteStatus ?? '-'}</Typography>
        </div>
        <div className="flex flex-col gap-y-3 pt-3">
          <DataLabel label={t('tracks')} />
          <MultiSelect
            label={t('tracks')}
            placeholder={t('all')}
            disabled
            selectedOptions={tracks ?? []}
            options={tracks ?? []}
            onChange={() => null}
            optionToName={(option) => option.name}
          />
        </div>
        {/* <Typography sx={{ mt: 4, mb: 0.5 }}>Training Experience</Typography>
          <Select fullWidth value={experience}>
            {zTrainingExperience.options.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select> */}

        {/* <Typography sx={{ mt: 2, mb: 0.5 }}>Tracks</Typography> */}
        {/** Replace with read-only multi-select containing tracks */}
        {/* <TextField select fullWidth /> */}
      </div>
      <DrawerFooter className="p-8">
        <div className="inline-flex justify-start w-full gap-2">
          <Button variant="outlined" onClick={() => onOpenChange(false)}>
            {t('cancel')}
          </Button>
        </div>
      </DrawerFooter>
    </Drawer>
  );
};
